import PlayerCardCondensed from "@/design-system/PlayerCard/PlayerCardCondensed";
import {
  PlayerFacts,
  useCrestFacts,
} from "@/pages/Sbcs/components/PlayerFacts";
import { SWAP_CARD_SCALE } from "@/pages/Sbcs/components/PlayerSwapPopover";
import { Player } from "@/types/SBCPlayer";

import { playerSource, toCardPlayer } from "./SolutionPlayerCard";

/* The solver sends ids as numbers, whatever the type says. */
const asId = (value?: string | number) =>
  value === undefined || value === null || value === ""
    ? undefined
    : Number(value);

/**
 * The solver's player facts. Club and nation ids ride on the payload; the
 * league id is the club's. The payload's own names cover a store that has not
 * loaded.
 */
export const SolutionPlayerFacts = ({ player }: { player: Player }) => {
  const facts = useCrestFacts({
    clubId: asId(player.club_id),
    countryId: asId(player.nation_id),
    fallback: {
      club: player.club,
      league: player.league,
      nation: player.nation,
    },
  });

  return (
    <PlayerFacts
      /* The solver's full_name is its search name; a brick has none. */
      searchName={player.full_name ?? player.name}
      source={playerSource(player)}
      card={
        <PlayerCardCondensed
          player={toCardPlayer(player)}
          position={player.position}
          scale={SWAP_CARD_SCALE}
          priceSize="small"
          untradeable={player.untradeable}
        />
      }
      facts={facts}
    />
  );
};
